/**
 * Handles promo functionality.
 */

import gsap from 'gsap';

( function( $ ) {

    const className = 'promo';
    const selector = `.${className}`;
    const bannerSelector = `${selector}__banner`;
    const spotsSelector = `${selector}__spots`;

    const rotateDuration = 0.75;
    const rotateEase = 'back.inOut';
    const maxResetDuration = 1.25;

    // Main methods (lolol)

    function animateBanner( banner ) {

        const jBanner = $( banner );
        const spotsEl = jBanner.find( spotsSelector );
        const spotsCount = parseInt( jBanner.data( 'spots' ) );

        if ( spotsCount <= 1 ) return

        const rotateDelay = jBanner.data( 'delay' );
        banner.timeline = gsap.timeline( { repeat: -1, paused: true } )

        for ( let i = 1; i < spotsCount; i++ ) {
            const translateY = -100 / spotsCount * i;
            banner.timeline.to( spotsEl, { y: `${translateY}%`, duration: rotateDuration, ease: rotateEase }, `+=${rotateDelay}` );
        }

        const resetDuration = Math.min( maxResetDuration, rotateDuration * ( spotsCount - 1 ) );

        banner.timeline.to( spotsEl, { y: 0, duration: resetDuration, ease: rotateEase }, `+=${rotateDelay}` )
            .play();
    }

    // Events

    function handleInteractionIn( e ) {
        if ( ! e.currentTarget.timeline ) return
        e.currentTarget.timeline.pause();
    }

    function handleInteractionOut( e ) {
        if ( ! e.currentTarget.timeline ) return
        e.currentTarget.timeline.play();
    }

    // Utils

    // Initialize

    $( window ).load( function() {

        const promos = $( selector );

        if ( promos.length ) {

            const banners = $( bannerSelector );

            $( 'body' ).addClass( 'has-promo' );

            banners.addClass( 'is-active' );
            banners.each( ( i ) => animateBanner( banners.get( i ) ) );

            banners.on( 'mouseenter focusin', handleInteractionIn )
            banners.on( 'mouseleave focusout', handleInteractionOut )
        }    

    } );
    
} )( jQuery );